import React, { FC } from 'react';
import {
  FeatureServiceFCO,
  FeatureServiceFCOFields,
  FeatureViewFCO,
  FeatureViewFCOFields,
  FeatureViewServingStatusSummaryWithId,
} from '../../../core/types/fcoTypes';
import { useFeatureServiceServingStatus } from '../../../feature/feature-services/feature-service/query';
import IdUtils from '../../../utils/id-utils';
import ServingStateChart from '../../@tecton/ComponentRedesign/ServingStatus';
import { useUserSettings } from '../../context/UserSettingsContext';
import { Empty, Loading } from '@lithos';

interface FeatureServiceMaterializationProps {
  featureService: FeatureServiceFCO;
  featureViews: FeatureViewFCO[];
}

const FeatureServiceMaterialization: FC<FeatureServiceMaterializationProps> = ({ featureService, featureViews }) => {
  const { workspace } = useUserSettings();

  const { data: fullServingStatusSummary, isLoading } = useFeatureServiceServingStatus(
    featureService.id,
    0,
    featureService[FeatureServiceFCOFields.ALL_FEATURE_VIEWS].length
  );

  if (isLoading || !fullServingStatusSummary) {
    return <Loading />;
  }

  const attemptStatuses: FeatureViewServingStatusSummaryWithId[] =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fullServingStatusSummary.feature_view_serving_status_summaries.map((summary: any) => {
      const actualId = IdUtils.toStringId(summary.feature_view_id);
      return {
        id: actualId,
        serving_status_summary: summary.serving_status_summary,
      };
    });

  const allFeatureViewsAreODFV = featureViews
    .map((featureView: FeatureViewFCO) => featureView[FeatureViewFCOFields.IS_REALTIME])
    .every((result: boolean) => result === true);

  if (allFeatureViewsAreODFV) {
    return (
      <Empty
        title="No Materialization Data Available"
        description="This Feature Service does not contain any Feature Views with materialization enabled."
        useCase="empty"
        placement="full-page"
        actions={[]}
      />
    );
  }

  return <ServingStateChart featureViews={featureViews} attemptSummary={attemptStatuses} workspace={workspace ?? ''} />;
};

export default FeatureServiceMaterialization;
